export const LOG_MODULES = [
  "",
  "auth",
  "retreat",
  "couple",
  "parish",
  "priest",
  "role",
  "service",
  "talk",
  "committee",
  "email",
  "help",
  "waitlist",
  "registration",
];

export const LOG_ACTIONS = [
  "",
  "Add",
  "Edit",
  "Delete",
  "Login",
  "Logout",
  "Assign",
  "Access",
  "Notify",
  "Lifecycle",
  "Publish",
  "Close",
];
